module.exports = __webpack_public_path__ + "static/media/0023_IMG_LE_CHARCUTIER.03f132ef.png";